define("shared/utils/handle-key-up", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = handleKeyUp;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  function handleKeyUp(event, key, action) {
    const eventKey = event.code || event.key;
    if (eventKey === key.code || eventKey === key.key) {
      event.preventDefault();
      action();
    }
  }
});